import React, { forwardRef } from 'react';
import './optionsACD.style.scss';

const OptionsADC = forwardRef(({ position, onGoToChallenge, onViewDetails, onDelete, justDelete, myChallenge }, ref) => {

    return (
        <div ref={ref} className="options-popup" style={{ top: position.y, left: position.x }}>
            <ul>
                {
                    myChallenge ? (
                        <li >View Details</li>
                    ) : justDelete === true ? (
                        <li onClick={onDelete}>Delete Challenge</li>
                    ) : (
                        <div>
                            <li onClick={onGoToChallenge}>Go to Challenge</li>
                            <li onClick={onViewDetails}>View Details</li>
                            <li onClick={onDelete}>Quit Challenge</li>
                        </div>
                    )
                }
            </ul>
        </div>
    );
});

export default OptionsADC;